var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M906 212L906 240",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 906.5,
    cy: 207.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M901.987 207.19C901.987 203.283 905.288 200.117 909.358 200.117C909.943 200.117 910.511 200.184 911.056 200.308C909.742 199.48 908.187 199 906.519 199C901.814 199 898 202.806 898 207.5C898 212.194 901.814 216 906.519 216C908.814 216 910.895 215.093 912.427 213.62C911.492 214.032 910.454 214.263 909.358 214.263C905.288 214.263 901.987 211.096 901.987 207.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M915.402 206.6L915.37 204.146L913.535 205.719L911.304 205.056L912.112 207.337L910.765 209.381L913.1 209.218L914.499 211.144L915.133 208.763L917.345 207.909L915.402 206.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.53bb9afefd8111d635bbb15cc0869681.svg";
export { ForwardRef as ReactComponent };